import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { SolarTotalItemForGroup } from 'services/Totals';

interface CachedSolarItem {
  [key: number]: SolarTotalItemForGroup[];
}

interface Props {
  cached?: CachedSolarItem;
  // current?: number;
  // dayTotal?: number;
  isVisible?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export type GroupTotalContextType = {
  cached: CachedSolarItem;
  setCached: Dispatch<SetStateAction<CachedSolarItem>>;
  // current: number;
  // setCurrent: Dispatch<SetStateAction<number>>;
  // dayTotal: number;
  // setDayTotal: Dispatch<SetStateAction<number>>;
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
};

const GroupTotalContext = createContext<GroupTotalContextType>({
  cached: {},
  setCached: () => console.warn('no GroupTotal provider'),
  // current: 0,
  // setCurrent: () => console.warn('no GroupTotal provider'),
  // dayTotal: 0,
  // setDayTotal: () => console.warn('no GroupTotal provider'),
  isVisible: false,
  setIsVisible: () => console.warn('no GroupTotal provider'),
  loading: false,
  setLoading: () => console.warn('no GroupTotal provider'),
});

export function useGroupTotalContext(): GroupTotalContextType {
  return useContext(GroupTotalContext);
}

export function GroupTotalProvider({ children }: Props): JSX.Element {
  const [cached, setCached] = useState<CachedSolarItem>({});
  // const [current, setCurrent] = useState<number>(0);
  // const [dayTotal, setDayTotal] = useState<number>(0);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <GroupTotalContext.Provider value={{ cached, setCached, isVisible, setIsVisible, loading, setLoading }}>
      {children}
    </GroupTotalContext.Provider>
  );
}
